import React from 'react';

import StatusChip from '~/components/core/StatusChip';

interface ExecutionStatusBadgeProps {
  status: string;
  className?: string;
}

const ExecutionStatusBadge: React.FC<ExecutionStatusBadgeProps> = ({ status, className }) => {
  const getStatusForChip = (status: string) => {
    switch (status.toUpperCase()) {
      case 'SUCCESS':
        return StatusChip.STATUSES.SUCCESS;
      case 'FAILED':
      case 'EXPIRED':
        return StatusChip.STATUSES.ERROR;
      case 'PROCESSING':
        return StatusChip.STATUSES.IN_PROGRESS;
      case 'PENDING':
        return StatusChip.STATUSES.PENDING;
      default:
        return status.toUpperCase();
    }
  };

  return (
    <div className={className}>
      <StatusChip status={getStatusForChip(status)} withIcon />
    </div>
  );
};

export default ExecutionStatusBadge;
